import type { CreateProductFeedbackRequest } from 'washday-sdk';
import WashdayClientSingleton from './WashdayClientSingleton';

export const createProductFeedback = (data: CreateProductFeedbackRequest) =>
  WashdayClientSingleton.getInstance().productFeedback.create(data);
